// Le statut d'adoption « À présenter » (toBePresented) est remplacé par « Publié » (published) :
// seuls les animaux publiés sont exposés par l'API externe.

async function applyJob() {
    const result = await global.app.C.Animal.collection.updateMany(
        {adoptionStatus: 'toBePresented'},
        {$set: {adoptionStatus: 'published'}}
    )
    return {message: `${result.modifiedCount} animal(aux) passé(s) au statut Publié`}
}

export const job = {
    name: "adaptAnimalAdoptionStatuses",
    title: "Passer les animaux « À présenter » au statut « Publié »",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(error => callback(error))
    }
}
